export default __webpack_public_path__ + "static/media/capsule-landing-token-matic.9d3ec9d1.png";